// Module
var code = `<div class="alert-selector" style="{{>visibility}}">
    <terceraLabel visible="{{visible}}" text="{{label}}" />

    <div class="alert-selector-right">
        <terceraNumeric tradingNumeric="{{.isTradingNumeric}}"
                        decimalPrecision="{{decimalPrecision}}"
                        minValue="{{minValue}}"
                        maxValue="{{maxValue}}"
                        step="{{step}}"
                        value="{{.numericValue}}"
                        customError="{{error}}"
                        Intervals="{{.intervals}}"
                        allowMinus="{{.allowMinus}}" />
    </div>
</div>`;
// Exports
export default code;